<template>
  <async-btn
    v-if="show"
    :task="task"
    v-bind="$attrs"
    rounded
    @click="reconnect"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import { isGranted } from '@/social/auth';
import { reconnect } from '.';
import { Account } from '../../../types';

interface Data {
  task: Promise<void>|null,
}

export default defineComponent({
  emits: ['reconnected'],
  components: { AsyncBtn },
  props: {
    account: {
      type: Object as () => Account,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  computed: {
    show(): boolean {
      return (
        isGranted('CONNECT_ACCOUNT')
        && (
          this.account.postsUntil === null
          || this.account.reconnectRequest !== null
        )
      );
    },
  },
  methods: {
    async reconnect() {
      this.task = reconnect(this.account);
      this.task.then(() => {
        this.$emit('reconnected');
      });
    },
  },
});
</script>
